import script from "./ExamenAdminsion.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamenAdminsion.vue?vue&type=script&setup=true&lang=js"

import "./ExamenAdminsion.vue?vue&type=style&index=0&id=2e20ec89&lang=css"

const __exports__ = script;

export default __exports__